module.exports = __webpack_public_path__ + "static/media/49.1c7136d2.png";